// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__rr8Uy","load2":"Spinner_load2__puWlA"};